// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jwW2","clinicsSelect":"styles_clinicsSelect__49CRF"};